import { useCreatePathWithQuery } from 'hooks/useCreatePathWithQuery';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { useRecordContext, useResourceContext } from 'react-admin';
import { Link } from 'react-router-dom';
import { Button, ButtonProps } from 'shared/mui/Buttons';

export type EditLinkButtonProps = ButtonProps;

export const EditLinkButton: React.FC<EditLinkButtonProps> = ({
  label,
  color = 'primary',
  variant = 'outlined',
  size = 'medium',
  ...restProps
}) => {
  const { createPathWithQuery } = useCreatePathWithQuery();
  const translate = useTypedTranslate();

  const resource = useResourceContext(restProps);
  const record = useRecordContext(restProps);

  const to = createPathWithQuery({
    resource,
    id: record?.id,
    type: 'edit',
  });

  return (
    <Button
      color={color}
      component={Link}
      label={label || translate('app.buttons.edit')}
      size={size}
      to={to}
      variant={variant}
      {...restProps}
    />
  );
};
